import {
  Box,
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import { Icon24Chevron } from '@care/react-embrace-icons';
import { ColumnarLinkedList } from '@/components/common/ColumnarLinkedList';
import { seoSegmentationListingPage_getSEOSegmentationLinkSections_linkList as SEOSegmentationLinkList } from '@/__generated__/seoSegmentationListingPage';
import { useResponsive } from '@/components/hooks/useResponsive';
import { useSearchDirectoryData } from '@/context/searchDirectory/SearchDirectoryDataContext';
import { useInternalLinking } from '@/components/feature/searchDirectory/hooks/useInternalLinking';

export const InternalLinkingSection = () => {
  const pageData = useSearchDirectoryData();
  const {
    seoSegmentationDetails: { internalLinkingHeadline },
  } = pageData;

  const headline =
    internalLinkingHeadline !== null &&
    internalLinkingHeadline !== 'null' &&
    internalLinkingHeadline !== ''
      ? internalLinkingHeadline
      : 'Additional Services';
  const internalLinkingSection = pageData.getSEOSegmentationLinkSections ?? null;

  const maplinkListToColumnarLinkList = (
    linkList: SEOSegmentationLinkList[]
  ): { name: string; link: string }[] => {
    return linkList.map(({ content, url }) => ({
      name: content,
      link: url,
    }));
  };

  const { isSmallViewport } = useResponsive();
  const sectionList = useInternalLinking(internalLinkingSection)?.map((section) => ({
    ...section,
    linkList: maplinkListToColumnarLinkList(section.linkList),
  }));

  if (!internalLinkingSection || !sectionList) {
    return null;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'background.secondary',
        pt: { xs: 6, sm: 8 },
        pb: { xs: 4, sm: 6 },
      }}>
      <Container maxWidth="lg">
        <Typography
          component="h3"
          variant={isSmallViewport ? 'h1' : 'display3'}
          sx={{
            mb: { xs: 4, sm: 6 },
            mt: 0,
          }}>
          {headline}
        </Typography>

        {sectionList.map(({ title, linkList }) => (
          <Accordion
            key={title}
            sx={{
              boxShadow: 0,
            }}>
            <AccordionSummary
              sx={{
                width: { sm: 'fit-content' },
                p: 0,
                mb: 3,
                '& .MuiAccordionSummary-content': {
                  mr: 2,
                },
              }}
              expandIcon={<Icon24Chevron />}>
              <Typography variant="h3">{title}</Typography>
            </AccordionSummary>
            <AccordionDetails
              sx={{
                p: 0,
              }}>
              <ColumnarLinkedList items={linkList} />
            </AccordionDetails>
          </Accordion>
        ))}
      </Container>
    </Box>
  );
};
